// filepath: c:\Project\DPA_\dpaweb\src\event-bus.js
import mitt from 'mitt'
export const EventBus = mitt()